export class Environment {
    private static get domainName() {
        const hostName = window.location.hostname;
        const domainParts = hostName.split('.');
        if (domainParts[0] === 'cademy' || domainParts[0] === process.env.REACT_APP_DOMAIN_PREFIX) {
            return hostName;
        }
        return domainParts.slice(1).join('.');
    }

    private static get baseDomainName() {
        return this.domainName.replace('dev.', '').replace('beta.', '');
    }

    private static get isLocal() {
        return !window.location.hostname || window.location.hostname.includes('localhost');
    }

    static get DOMAIN_NAME() {
        return this.domainName;
    }

    static get DOMAIN() {
        return this.domainName;
    }

    static get API_URL() {
        if (this.isLocal) {
            return process.env.REACT_APP_API_URL!;
        }
        return `https://api.${this.domainName}`;
    }

    static get SOCKET_URL() {
        if (this.isLocal) {
            return process.env.REACT_APP_SOCKET_URL!;
        }
        return `wss://sockets.${this.domainName}`;
    }

    static get ADMIN_APP_URL() {
        if (this.isLocal) {
            return process.env.REACT_APP_ADMIN_APP_URL!;
        }
        return `https://admin.${this.domainName}`;
    }

    static get MARKETPLACE_URL() {
        if (this.isLocal) {
            return process.env.REACT_APP_MARKETPLACE_URL!;
        }
        return `https://${this.domainName}`;
    }

    static get ASSETS_URL() {
        if (this.isLocal) {
            return process.env.REACT_APP_ASSETS_URL!;
        }
        return `https://assets.${this.baseDomainName}`;
    }

    static get CADEMY_ROADMAP_URL() {
        return process.env.REACT_APP_CADEMY_ROADMAP_URL;
    }

    static get CADEMY_SUPPORT_EMAIL_ADDRESS() {
        if (this.isLocal) {
            return process.env.REACT_APP_CADEMY_SUPPORT_EMAIL_ADDRESS!;
        }
        return `support@${this.domainName}`;
    }

    static get STRIPE_PUBLISHABLE_KEY() {
        return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    }

    static get ENVIRONMENT() {
        return process.env.REACT_APP_ENVIRONMENT;
    }

    static get POSTHOG_KEY() {
        return process.env.REACT_APP_POSTHOG_KEY;
    }

    static get RECAPTCHA_KEY() {
        return process.env.REACT_APP_RECAPTCHA_KEY;
    }

    static get PAYPAL_CLIENT_ID() {
        return process.env.REACT_APP_PAYPAL_CLIENT_ID;
    }

    static get GOOGLE_MAPS_API_KEY() {
        return process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    }

    static get SCORM_WRAPPER_URL() {
        return process.env.REACT_APP_SCORM_WRAPPER_URL;
    }
}
